import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalContent = 'privacy' | 'terms' | null;
const privacyContent = `Política de Privacidad

Última actualización: febrero 2026

En "3AM otra vez" respetamos tu privacidad. Esta política describe cómo recopilamos, usamos y protegemos tu información personal.

Información que recopilamos
• Correo electrónico (solo si lo proporcionas voluntariamente al comprar).
• Información de pago procesada de forma segura por nuestro proveedor de pagos. No almacenamos datos de tarjetas.

Uso de la información
• Para enviarte el producto digital que compraste.
• Para comunicarnos contigo sobre tu compra.
• No vendemos, alquilamos ni compartimos tu información personal con terceros.

Cookies
• Usamos cookies básicas para el funcionamiento del sitio. No usamos cookies de rastreo publicitario.

Tus derechos
• Puedes solicitar la eliminación de tus datos en cualquier momento.
• Puedes solicitar una copia de la información que tenemos sobre ti.

Cambios a esta política
• Nos reservamos el derecho de actualizar esta política. Los cambios se publicarán en esta página.`;
const termsContent = `Términos y Condiciones

Última actualización: febrero 2026

Al comprar "3AM otra vez" (Kit Anti-Despertar Nocturno), aceptas los siguientes términos:

Producto digital
• "3AM otra vez" es un producto digital descargable en formato PDF.
• Recibirás acceso inmediato tras completar tu compra.

Uso personal
• El contenido es para tu uso personal únicamente.
• No está permitido redistribuir, revender ni compartir el material.

Descargo de responsabilidad
• Este kit NO es consejo médico. Es un recurso educativo e informativo.
• No sustituye la consulta con un profesional de salud.
• Si tienes condiciones médicas, consulta a tu médico antes de seguir cualquier protocolo.

Política de reembolso
• Debido a la naturaleza digital del producto, todas las ventas son finales.
• Si tienes problemas con la descarga, contáctanos y te ayudaremos.

Propiedad intelectual
• Todo el contenido del kit está protegido por derechos de autor.
• © ${new Date().getFullYear()} 3AM otra vez. Todos los derechos reservados.`;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalContent>(null);
  const openModal = (type: ModalContent) => setActiveModal(type);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="py-10 bg-warm-900 border-t border-warm-800" data-id="element-41">
        <div className="max-w-2xl mx-auto px-6 flex flex-col items-center gap-4" data-id="element-42">
          <div className="flex items-center gap-6 text-sm" data-id="element-43">
            <button onClick={() => openModal('privacy')} className="text-cream-100/50 hover:text-amber-500 transition-colors duration-200 underline underline-offset-2 decoration-cream-100/20 hover:decoration-amber-500" data-id="element-44">
              Política de Privacidad
            </button>
            <span className="text-cream-100/20" data-id="element-45">|</span>
            <button onClick={() => openModal('terms')} className="text-cream-100/50 hover:text-amber-500 transition-colors duration-200 underline underline-offset-2 decoration-cream-100/20 hover:decoration-amber-500" data-id="element-46">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-cream-100/30 text-xs" data-id="element-47">
            © {new Date().getFullYear()} 3AM otra vez. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-48">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={closeModal} data-id="element-49">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="relative w-full max-w-lg max-h-[80vh] bg-warm-800 border border-warm-700 rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-50">
              <div className="flex items-center justify-between p-5 border-b border-warm-700" data-id="element-51">
                <h3 className="text-lg font-serif text-cream-50" data-id="element-52">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={closeModal} className="p-1.5 rounded-lg text-cream-100/50 hover:text-cream-50 hover:bg-warm-700 transition-colors" data-id="element-53">
                  <XIcon className="w-5 h-5" data-id="element-54" />
                </button>
              </div>

              <div className="p-5 overflow-y-auto max-h-[calc(80vh-64px)] text-sm text-cream-100/80 leading-relaxed whitespace-pre-line" data-id="element-55">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}